<script setup>
import { computed } from 'vue';

const props = defineProps({
  rows: { type: Array, default: () => [] },
});

const maxVotes = computed(() =>
  Math.max(1, ...props.rows.map(r => r.estimatedVotes || 0))
);
</script>

<template>
  <div class="rounded-xl border border-n-strong/40 bg-n-background p-5">
    <div class="mb-4 flex items-center gap-2">
      <span class="i-lucide-map-pin size-4 text-n-slate-11" />
      <h3 class="text-sm font-bold text-n-slate-12">Cobertura por cidade</h3>
    </div>

    <div v-if="rows.length" class="space-y-1.5">
      <div
        v-for="r in rows.slice(0, 15)"
        :key="r.city"
        class="flex items-center gap-2"
      >
        <span class="w-32 truncate text-xs font-semibold text-n-slate-12">{{
          r.city
        }}</span>
        <div class="relative h-5 flex-1 overflow-hidden rounded bg-n-slate-2">
          <div
            class="absolute inset-y-0 left-0 bg-gradient-to-r from-blue-500 to-indigo-600"
            :style="`width: ${(r.estimatedVotes / maxVotes) * 100}%`"
          />
        </div>
        <span class="w-16 text-right text-[11px] font-semibold text-n-slate-12">
          {{ r.estimatedVotes.toLocaleString('pt-BR') }}
        </span>
        <span class="w-12 text-right text-[10px] text-n-slate-11">
          {{ r.workers }} cabos
        </span>
      </div>
    </div>

    <div v-else class="py-6 text-center text-xs text-n-slate-11">
      Cadastre cabos com cidade para ver o ranking.
    </div>
  </div>
</template>
